// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2lhbS","tab":"ProcedureTabs_tab__3sMF2"};